import { Sidebar } from 'primereact/sidebar';
import React, { useState } from 'react';
import { CgMathPlus } from 'react-icons/cg';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const PublicSideBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const { userIsLoggedIn } = useSelector((state) => state.datosUsuarios.dataUsuario);

  return (
    <React.Fragment>
      <button className="nav__button__sidebar d-flex d-lg-none" onClick={toggle}>
        <CgMathPlus />
      </button>

      <Sidebar
        className="text-dark-black"
        visible={isOpen}
        baseZIndex={1000000}
        onHide={toggle}
      >
        <h6 className="text-center text-mex" style={{ fontSize: '30px' }}>
          Menú
        </h6>
        <ul className="list-unstyled mt-5">
          <li className="sidebar__item__link">
            <Link to="/" className="text-decoration-none" onClick={toggle}>
              Personas
            </Link>
          </li>

          <li className="sidebar__item__link">
            <Link to="/empresas" className="text-decoration-none" onClick={toggle}>
              Empresas
            </Link>
          </li>

          {!userIsLoggedIn && (
            <React.Fragment>
              <li className="sidebar__item__link">
                <Link
                  to="/login?user=clientes"
                  className="text-decoration-none"
                  onClick={toggle}
                >
                  Soy Cliente
                </Link>
              </li>
              <li className="sidebar__item__link">
                <Link
                  to="/login?user=agentes"
                  className="text-decoration-none"
                  onClick={toggle}
                >
                  Soy Agente o Broker
                </Link>
              </li>
            </React.Fragment>
          )}
        </ul>
      </Sidebar>
    </React.Fragment>
  );
};

export default PublicSideBar;
